import { SymbolTypes } from '~/types/models/symbol';

// TODO review the labels props and possibly rename th em. Define an explicit default tab here in addition to the overview tab key.
// TODo review the comments here

/**
 * Number of headlines shown in the desktop grid (2 columns x 2 rows) in HeadlinesWrapper
 */
export const DESKTOP_HEADLINES_GRID_MAX_COUNT = 4;

/**
 * Tab key for the market overview tab. Kept as a single source of truth since it's compared
 * against directly in several places, unlike the other tabs which already
 * use the SymbolTypes enum.
 */
export const MARKET_OVERVIEW_TAB_KEY = 'market';

/**
 * Tabs shown on the market page
 */
export const MARKET_PAGE_TABS = [
  { key: MARKET_OVERVIEW_TAB_KEY, label: 'market_page_overview' },
  { key: SymbolTypes.INDEX, label: 'indices' },
  { key: SymbolTypes.STOCKS, label: 'stocks' },
  { key: SymbolTypes.ETF, label: 'etfs' },
  { key: SymbolTypes.CRYPTO, label: 'cryptos' },
];

/**
 * Number of asset items shown per card (indices, key figures, gainers, losers) in the
 * markets page overview tab (MarketOverviewTabContent, TitledThreeColumnAssetChangeCardSkeleton)
 */
export const MARKET_OVERVIEW_ASSET_CARD_ITEMS_COUNT = 5;
